import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Loader, Modal } from '@grandvisionhq/common';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { Hooks } from '@grandvisionhq/stores-v2';
import { useDynamicModule } from '@grandvisionhq/utils';
import { pushLoginExpressEditUserDetailsClickEventToDataLayer } from '../../../../data-layer.js';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/graphql';
import '@grandvisionhq/payments';
import '@grandvisionhq/api-client';
import '../../../../StepShipping/selectors.js';
import 'lodash/isEmpty';
import '../../../../mappers/errors-mapping.js';
import '../../../../utils/get-customer-details-payload.js';
import '../../../../models/cart/cart-state.js';
import '../../../../models/checkout/checkout-step-error-type.js';
import '../../../../models/checkout-settings.js';
import '../../../../models/step-shipping/shipping-methods.js';
import '../../../../models/shared.js';
import 'history';
import '../../../../utils/has-cart-errors.js';
import '@grandvisionhq/auth';
import '../../../../context/CheckoutSettings/context.js';
import '../../../../selectors.js';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../../../../operations/mutations/set-customer-details.js';
import '../../../../operations/mutations/set-service-store.js';
import '../../../../operations/mutations/set-shipping-method.js';
import '../../../../operations/mutations/set-shipping-state.js';
import '../../../../operations/mutations/create-apple-pay-session.js';
import '../../../../operations/mutations/recreate-ordered-checkout.js';
import { useSetServiceStore } from '../../../../hooks/operations/use-set-service-store.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../../../../operations/fragments/checkout-mutation-result.js';
import '../../../../operations/fragments/cart-mutation-failures.js';
import '../../../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../../../operations/fragments/paypal-payment.js';
import '../../../../operations/fragments/saved-user-details.js';
import '../../../../operations/queries/get-checkout-state.js';
import '../../../../operations/queries/get-user-details.js';
import { StoreSummary } from '../../../../modules/ServiceStore/components/StoreSummary.js';
import { StoreFinderItemContainer } from '../../../../modules/ServiceStore/containers/StoreFinderItemContainer.js';
import { useLoggedInCheckout } from '../../../context/context.js';
import '@grandvisionhq/lib-utils-w3c';

const loadModule = function() {
    var _ref = swcHelpers.asyncToGenerator(function*() {
        const storesModule = yield import('@grandvisionhq/stores-v2');
        return storesModule;
    });
    return function loadModule() {
        return _ref.apply(this, arguments);
    };
}();
const usePickupStoresModule = ()=>useDynamicModule(loadModule, '@grandvisionhq/stores-v2', [])
;
const ServiceStoreSummary = ({ globalStoreId: globalStoreId1 , updateStore , cartStoreId , title , isServiceStoreValid , isOrderDetailsValid  })=>{
    const { getLabel  } = useIntl();
    const [showModal, setShowModal] = React.useState(false);
    const globalStoreIdRef = React.useRef(undefined);
    const [module, loading, error] = usePickupStoresModule();
    const [serviceStoreState, setServiceStoreState] = React.useState(null);
    const { shippingState , isUserLoggedIn  } = useLoggedInCheckout();
    const [storeDetails, setStoreDetails] = React.useState({
        name: '',
        streetName: '',
        streetNumber: ''
    });
    const onSetStoreSuccess = React.useCallback(()=>{
        if (shippingState.serviceStore) {
            const { name , streetName , streetNumber  } = shippingState.serviceStore;
            setServiceStoreState(shippingState.serviceStore);
            setStoreDetails({
                name,
                streetName,
                streetNumber
            });
        }
    }, [
        shippingState.serviceStore
    ]);
    const { setServiceStore  } = useSetServiceStore({
        onCompleted: onSetStoreSuccess
    });
    const labels = React.useMemo(()=>({
            title: getLabel('checkout.serviceStore.title'),
            subtitle: getLabel('checkout.serviceStore.subtitle'),
            errorMessage: getLabel('checkout.serviceStore.error')
        })
    , [
        getLabel
    ]);
    const featuresToggles = useFeatureToggles();
    const [getStoreById, storeById] = Hooks.useStoreById();
    const handleStoreFinder = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        if (!globalStoreId1) return;
        if (cartStoreId !== globalStoreId1 && globalStoreId1 !== globalStoreIdRef.current) {
            if (!shippingState.serviceStore) {
                getStoreById({
                    variables: {
                        globalStoreId: globalStoreId1
                    }
                });
            }
            if (shippingState.serviceStore && !serviceStoreState) {
                const { name , streetName , streetNumber  } = shippingState.serviceStore;
                setServiceStoreState(shippingState.serviceStore);
                setStoreDetails({
                    name,
                    streetName,
                    streetNumber
                });
            }
            globalStoreIdRef.current = globalStoreId1;
            yield setServiceStore(globalStoreId1);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [
        cartStoreId,
        getStoreById,
        globalStoreId1,
        serviceStoreState,
        shippingState.serviceStore
    ]);
    React.useEffect(()=>{
        handleStoreFinder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        globalStoreId1
    ]);
    const onStoreSelect = React.useCallback((store)=>{
        if (store === null || store === void 0 ? void 0 : store.globalStoreId) {
            const { globalStoreId , name , town , streetName , streetNumber  } = store;
            setServiceStoreState({
                globalStoreId,
                name,
                streetName,
                town
            });
            updateStore({
                globalStoreId,
                name,
                streetName,
                town
            });
            setStoreDetails({
                name,
                streetName,
                streetNumber
            });
        }
        setShowModal(false);
    }, [
        updateStore
    ]);
    const onEditHandler = React.useCallback(()=>{
        pushLoginExpressEditUserDetailsClickEventToDataLayer({
            editType: isServiceStoreValid ? 'edit_service_store' : 'add_service_store_alert',
            isLoggedIn: isUserLoggedIn
        });
        setShowModal(true);
    }, [
        isServiceStoreValid,
        isUserLoggedIn
    ]);
    React.useEffect(()=>{
        if (storeById.error) {
            setServiceStoreState(null);
            setStoreDetails({
                name: '',
                streetName: '',
                streetNumber: ''
            });
            updateStore(null);
            return;
        }
        if (storeById.data && storeById.data.globalStoreId !== (serviceStoreState === null || serviceStoreState === void 0 ? void 0 : serviceStoreState.globalStoreId)) {
            const { globalStoreId , name , streetName , streetNumber , town  } = storeById.data;
            const newServiceStore = {
                globalStoreId,
                name,
                streetName,
                streetNumber,
                town
            };
            setServiceStoreState(newServiceStore);
            updateStore(newServiceStore);
            setStoreDetails({
                name,
                streetName,
                streetNumber
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        serviceStoreState === null || serviceStoreState === void 0 ? void 0 : serviceStoreState.globalStoreId,
        storeById.data,
        storeById.error
    ]);
    if (error || !module) {
        return /*#__PURE__*/ React.createElement(Alert, {
            variant: "error",
            notifyScreenReader: false,
            className: "alert-m-default"
        }, labels.errorMessage);
    }
    const { Components , Containers , StoreFinderProvider  } = module;
    const { StoreFinder , PickUpButtons , withPickUpButtonsConfig  } = Containers;
    const { StoreListTopContent  } = Components;
    if (loading) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal, {
        className: "service-store__modal",
        showIcon: true,
        iconClassName: "service-store__modal__close",
        isOpen: showModal,
        onModalClose: ()=>setShowModal(false)
    }, /*#__PURE__*/ React.createElement(StoreFinderProvider, {
        googleMapsId: "google-maps-service-store",
        hidePhone: !featuresToggles.isStorePickupPhoneEnabled,
        hideEmail: !featuresToggles.isStorePickupEmailEnabled
    }, /*#__PURE__*/ React.createElement(StoreFinder, {
        isInsideModal: true,
        listTopContent: /*#__PURE__*/ React.createElement(StoreListTopContent, {
            title: labels.title,
            description: labels.subtitle
        }),
        listItemComponent: (props)=>/*#__PURE__*/ React.createElement(StoreFinderItemContainer, swcHelpers.extends({}, props, {
                variant: 'list-item',
                onClick: onStoreSelect
            }))
        ,
        infoWindowContentComponent: (props)=>/*#__PURE__*/ React.createElement(StoreFinderItemContainer, swcHelpers.extends({}, props, {
                variant: 'map-item',
                onClick: onStoreSelect
            }))
        ,
        buttonsComponent: withPickUpButtonsConfig(PickUpButtons, {
            onStoreSelect
        })
    }))), /*#__PURE__*/ React.createElement(StoreSummary, swcHelpers.extends({}, storeDetails, {
        actions: {
            onEdit: onEditHandler
        },
        title: title,
        errorNotification: !isServiceStoreValid ? /*#__PURE__*/ React.createElement(Alert, {
            className: "alert-m-default ",
            role: isOrderDetailsValid ? 'status' : 'alert',
            variant: isOrderDetailsValid ? 'info' : 'error',
            title: getLabel('checkout.serviceStore.incomplete.title')
        }, getLabel('checkout.information.incomplete.message')) : null
    })));
};

export { ServiceStoreSummary };
//# sourceMappingURL=ServiceStoreSummary.js.map
